import React from 'react';
import parseHtmlListToArray from 'swag-client-common/utils/html-list-to-array.util';
import classnames from 'classnames';
import classes from './extendable-specs.scss';
export default class ExtendableSpecs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExtended: false,
      specs: parseHtmlListToArray(props.specs)
    };
    this.toggleExtended = this.toggleExtended.bind(this);
  }
  toggleExtended() {
    this.setState({
      isExtended: !this.state.isExtended
    });
  }
  render() {
    const {
      isExtended,
      specs
    } = this.state;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: classes.specs
    }, specs.map((spec, index) => {
      return /*#__PURE__*/React.createElement("li", {
        className: classnames({
          [classes.hiddenItem]: index > 3 && !isExtended
        }),
        key: spec
      }, spec);
    })), specs.length > 4 && /*#__PURE__*/React.createElement("span", {
      onClick: this.toggleExtended,
      className: classnames(classes.greyLink, classes.actionElement, classes.showMoreToggle)
    }, "Show ", isExtended ? 'less' : 'more'));
  }
}